// Modal de criar/editar lista de contatos (aba Listas de Campanhas), no
// padrão Aeros Dark: casca AerosDialog + campos de styles/aerosModalStyles.
import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const ContactListModal = ({ open, onClose, contactListId }) => {
  const m = useAerosModalStyles();

  const [name, setName] = useState("");
  const [touched, setTouched] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setTouched(false);
    if (!contactListId) {
      setName("");
      return;
    }
    const fetchContactList = async () => {
      try {
        const { data } = await api.get(`/contact-lists/${contactListId}`);
        setName(data?.name || "");
      } catch (err) {
        toastError(err);
      }
    };
    fetchContactList();
  }, [contactListId, open]);

  const trimmed = name.trim();
  // Mesma regra do schema Yup anterior: 2 a 50 caracteres.
  const tooShort = trimmed.length < 2;
  const tooLong = trimmed.length > 50;
  const nameError = touched && (tooShort || tooLong);
  const nameHelper = nameError
    ? tooLong
      ? i18n.t("contactLists.dialog.nameTooLong")
      : i18n.t("contactLists.dialog.nameRequired")
    : "";

  const handleClose = () => {
    onClose();
    setName("");
    setTouched(false);
  };

  const handleSave = async () => {
    setTouched(true);
    if (tooShort || tooLong) return;
    setSaving(true);
    try {
      if (contactListId) {
        await api.put(`/contact-lists/${contactListId}`, { name: trimmed });
      } else {
        await api.post("/contact-lists", { name: trimmed });
      }
      toast.success(i18n.t("contactList.dialog"));
      handleClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AerosDialog
      open={open}
      onClose={handleClose}
      width={480}
      title={i18n.t(
        contactListId
          ? "contactLists.dialog.editTitle"
          : "contactLists.dialog.addTitle"
      )}
      subtitle={i18n.t("contactLists.dialog.subtitle")}
      onSubmit={handleSave}
      loading={saving}
      submitLabel={i18n.t(
        contactListId ? "contactLists.dialog.okEdit" : "contactLists.dialog.okAdd"
      )}
      cancelLabel={i18n.t("contactLists.dialog.cancel")}
    >
      <div>
        <label
          className={`${m.fieldLabel} ${
            !nameError && trimmed ? m.fieldLabelFocus : ""
          }`}
          htmlFor="contact-list-name"
        >
          {i18n.t("contactLists.dialog.name")}
        </label>
        <TextField
          id="contact-list-name"
          variant="outlined"
          className={m.input}
          value={name}
          autoFocus
          onChange={(e) => setName(e.target.value)}
          onBlur={() => setTouched(true)}
          onKeyDown={(e) => e.key === "Enter" && handleSave()}
          error={nameError}
          helperText={nameHelper}
        />
      </div>
    </AerosDialog>
  );
};

export default ContactListModal;
